import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import Loader from "./loader";

const Table = ({ header, sort, total, onSort, loading, children, fixed = false, sticky = false, className = "h-full bg-white" }) => {
  if (total === 0 && !loading) return <div className="w-full px-3 py-5">No data found</div>;

  if (loading) {
    return (
      <div className="w-full flex justify-center items-center">
        <Loader />
      </div>
    );
  }

  return (
    <div className={`w-full border rounded overflow-x-auto no-scrollbar ${className}`}>
      <table className={`w-full ${fixed ? "table-fixed" : ""}`}>
        <thead className={`text-left ${sticky ? "sticky top-0 z-10 bg-white shadow-sm" : ""}`}>
          <tr className="border-b">
            {header.map((item, index) => {
              return (
                <th key={index} className="p-2" colSpan={item.colSpan || 1}>
                  <div className={`flex items-center gap-2 ${item.position === "right" ? "justify-end" : item.position === "center" ? "justify-center" : "justify-start"}`}>
                    <h3 className="text-sm font-semibold">{item.title}</h3>
                    {item.key && (
                      <button
                        className="h-4 flex flex-col justify-center"
                        onClick={() => {
                          if (!item.key) return;
                          if (!onSort) return;
                          onSort(item.key);
                        }}>
                        {sort && sort[item.key] === 1 ? (
                          <IoIosArrowUp className="text-secondary" />
                        ) : sort && sort[item.key] === -1 ? (
                          <IoIosArrowDown className="text-secondary" />
                        ) : (
                          <>
                            <IoIosArrowUp className="text-secondary" />
                            <IoIosArrowDown className="text-secondary" />
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="relative">
          {loading ? (
            <tr>
              <td colSpan={header.reduce((acc, item) => acc + (item.colSpan || 1), 0)}>
                <div className="py-4 flex w-full justify-center bg-gray-50">
                  <Loader />
                </div>
              </td>
            </tr>
          ) : total === 0 ? (
            <tr>
              <td colSpan={header.reduce((acc, item) => acc + (item.colSpan || 1), 0)} className="py-4 text-center bg-gray-50">
                Aucune donnée trouvée
              </td>
            </tr>
          ) : (
            children
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
